import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import LogoSmall from "images/logoSmall.svg";
import UserIcon from "images/UserIcon";
import Hamburger from "components/Hamburger/Hamburger";

const MobileAdminAppBar = ({ user, hamburgerFilter, selectPractice }) => {
  return (
    <Wrapper>
      <ContentGrouper>
        <LogoWrapper src={LogoSmall} />
        <AppBarText>Admin panel</AppBarText>
      </ContentGrouper>

      <ContentGrouper>
        <UserIcon />
        <AppBarText>{user.firstName}</AppBarText>
        <Hamburger
          isAdminPage
          selectPractice={selectPractice}
          filter={hamburgerFilter}
        />
      </ContentGrouper>
    </Wrapper>
  );
};

MobileAdminAppBar.propTypes = {
  user: PropTypes.object,
  selectPractice: PropTypes.func,
  hamburgerFilter: PropTypes.any,
};

const AppBarText = styled.span`
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
`;

const Wrapper = styled.div`
  max-height: 43px;
  background-color: white;
  height: 100%;
  padding: 6px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #649aaf;
`;

const LogoWrapper = styled.img`
  height: 100%;
  max-height: 30px;
  width: auto;
`;

const ContentGrouper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  // Space between items
  & > *:not(:first-child) {
    margin-left: 8px;
  }
`;

export default MobileAdminAppBar;
